import { render, staticRenderFns } from "./imageModal.vue?vue&type=template&id=5dee3f3e&"
import script from "./imageModal.vue?vue&type=script&lang=js&"
export * from "./imageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5dee3f3e', component.options)
    } else {
      api.reload('5dee3f3e', component.options)
    }
    module.hot.accept("./imageModal.vue?vue&type=template&id=5dee3f3e&", function () {
      api.rerender('5dee3f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/ProductInfo/Scripts/imageModal.vue"
export default component.exports